import * as Preact from "preact"
import "@frog/source/views/components/EncounterArea.less"
import Dev from "@frog/source/models/admin/Dev.js"

export default class EncounterArea {
    render() {
        const zone = this.props.encounter
        const minX = Math.min(...zone.points.map((point) => point.x))
        const maxX = Math.max(...zone.points.map((point) => point.x))
        const minY = Math.min(...zone.points.map((point) => point.y))
        const maxY = Math.max(...zone.points.map((point) => point.y))

        let polygon = []
        if(zone.points != undefined) {
            polygon = [
                ...zone.points,
                zone.points[0]
            ]
            polygon = polygon.map((point) => {
                return {
                    "x": point.x - minX,
                    "y": point.y - minY,
                }
            })
        } else {
            const x1 = 0
            const y1 = 0
            const x2 = 0 + zone.width
            const y2 = 0 + zone.height
            polygon = [
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
                {"x": x1, "y": y1},
            ]
        }
        const polygonStrings = polygon.map((point) => {
            return point.x + "em" + " " + point.y + "em"
        })

        return (
            <div
                class="EncounterArea"
                isHovered={this.isHovered + ""}
                style={{
                    "width": maxX - minX + "em",
                    "height": maxY - minY + "em",
                    "left": minX + "em",
                    "top": minY + "em",
                    "clip-path": "polygon(" + polygonStrings.join(", ") + ")",
                }}
            />
        )
    }
    get isHovered() {
        return this.props.encounter.slug == Dev.devSelection.hoveredEncounterKey
            || this.props.encounter.slug == Dev.devSelection.listHoveredEncounterKey
    }
}
